import { createReducer } from "@reduxjs/toolkit";
import {
    clearCompounds,
    estimateCompound,
    loadCompounds,
} from "../actions/pocketbook";
import {
    clearSearchBarModalInstance,
    closeSearchBarModal,
    openSearchBarModal,
    startLoading,
    stopLoading,
} from "../actions/searchbar";

export type ISearchBarState = {
    loading: boolean;
    activeModalByInstance: Record<string, string | null>;
};

const getDefaultState = (): ISearchBarState => ({
    loading: false,
    activeModalByInstance: {},
});

export const searchbar = createReducer(getDefaultState(), (builder) => {
    builder
        .addCase(startLoading, (state) => {
            state.loading = true;
        })
        .addCase(loadCompounds.request, (state) => {
            state.loading = true;
        })
        .addCase(stopLoading, (state) => {
            state.loading = false;
        })
        .addCase(clearCompounds, (state) => {
            state.loading = false;
        })
        .addCase(loadCompounds.success, (state) => {
            state.loading = false;
        })
        .addCase(loadCompounds.error, (state) => {
            state.loading = false;
        })
        .addCase(estimateCompound.request, (state) => {
            state.loading = false;
        })
        .addCase(openSearchBarModal, (state, action) => {
            const instanceId = action.payload?.instanceId;
            const modalKey = action.payload?.modalKey;
            if (!instanceId || !modalKey) {
                return;
            }
            state.activeModalByInstance[instanceId] = modalKey;
        })
        .addCase(closeSearchBarModal, (state, action) => {
            const instanceId = action.payload?.instanceId;
            const modalKey = action.payload?.modalKey;
            if (!instanceId || !modalKey) {
                return;
            }
            if (state.activeModalByInstance[instanceId] === modalKey) {
                state.activeModalByInstance[instanceId] = null;
            }
        })
        .addCase(clearSearchBarModalInstance, (state, action) => {
            const instanceId = action.payload?.instanceId;
            if (!instanceId) {
                return;
            }
            delete state.activeModalByInstance[instanceId];
        });
});
